import {omneticApi as api} from '@dms/api/base';

import {
  CreateTestDriveApiArg,
  CreateTestDriveApiResponse,
  GetTestDriveApiResponse,
  GetTestDriveApiArg,
  ListTestDriveApiResponse,
  ListTestDriveApiArg,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBusinessCaseTestDrive: build.query<GetTestDriveApiResponse, GetTestDriveApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/test-drive`,
        params: {businessCaseId: queryArg.businessCaseId},
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'BusinessCaseTestDrive', id: queryArg.businessCaseId},
      ],
    }),
    createTestDrive: build.mutation<CreateTestDriveApiResponse, CreateTestDriveApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/test-drive`,
        method: 'POST',
        body: queryArg.createTestDriveRequestBody,
        params: {businessCaseId: queryArg.businessCaseId},
      }),
      invalidatesTags: (_result, _error, queryArg) => {
        const tags: Array<
          | {type: 'BusinessCaseTestDrive'; id: string}
          | {type: 'VehicleTestDrives'; id: string}
          | {type: 'BusinessCaseActivity'; id: string}
        > = [
          {type: 'BusinessCaseTestDrive', id: queryArg.businessCaseId},
          {type: 'BusinessCaseActivity', id: queryArg.businessCaseId},
        ];
        if (queryArg.createTestDriveRequestBody.vehicleId) {
          tags.push({
            type: 'VehicleTestDrives',
            id: queryArg.createTestDriveRequestBody.vehicleId,
          });
        }
        return tags;
      },
    }),
    listBusinessCaseTestDrives: build.query<ListTestDriveApiResponse, ListTestDriveApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/${queryArg.businessCaseId}/test-drive`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'BusinessCaseTestDrive', id: queryArg.businessCaseId},
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBusinessCaseTestDriveQuery,
  useCreateTestDriveMutation,
  useListBusinessCaseTestDrivesQuery,
} = injectedRtkApi;
